<br />
<!--div *ngIf="!showMailView&&!showLabelsAsHtml" class="form-row btntop col-sm-12" style="margin-top: 10px;">
  <table>
    <tr>
      <td>
        <button class="btn border" (click)="search()">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="clear()">Rensa</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="expanded = !expanded;expandedlabel==='Stäng grupper'? expandedlabel='Öppna grupper' : expandedlabel='Stäng grupper'">{{expandedlabel}}</button>
      </td>
    </tr>
    <tr>
  <td class="reportlabel">Rapport: Medlemmar<i *ngIf="showSpinner" class="pi pi-spin pi-spinner" style="font-size:22px;color:#920000;margin-left:30px;"></i></td>
  </tr>
  </table>
  
</div-->

<div
  *ngIf="!showMailView && !showLabelsAsHtml"
  class="ms-3 d-flex justify-content-start mt-2 mb-2 mx-2"
>
  <div class="d-flex" style="gap: 1rem">
    <button class="btn border" (click)="search()">Sök</button>
    <button class="btn border" (click)="clear()">Rensa</button>
    <button
      class="btn border"
      (click)="
        expanded = !expanded;
        expandedlabel === 'Stäng grupper'
          ? (expandedlabel = 'Öppna grupper')
          : (expandedlabel = 'Stäng grupper')
      "
    >
      {{ expandedlabel }}
    </button>
    <div class="reportlabel">
      Rapport: Medlemmar<i
        *ngIf="showSpinner"
        class="fa fa-spinner fa-spin"
        style="font-size: 22px; color: #920000; margin-left: 30px"
      ></i>
    </div>
  </div>
</div>

<div *ngIf="!showMailView && !showLabelsAsHtml" class="ms-3 col-lg-11">
  <form [formGroup]="memberform" (keydown.enter)="search()">
    <div class="row">
      <div class="col-xs-12 col-md-6 col-xl-4">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title> Medlem </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>


            

          <div class="col-sm-12 form-check-inline">
            <mat-checkbox formControlName="onlyActiveMembers">Sök endast bland aktiva medlemmar</mat-checkbox>
          </div>

     

          <div class="row">
            <div class="form-group col-md-6">
              <label> Medlemsnummer </label>
              <div class="row">
                <div class="col-md-5">
                  <input
                    id="memberIdFrom"
                    type="text"
                    class="col-sm-6 col-md-11 col-lg-11 form-control form-control-sm cap"
                    formControlName="memberIdFrom"
                  />
                </div>
                --
                <div class="col-md-5">
                  <input
                    id="memberIdTo"
                    type="text"
                    class="col-sm-11 col-md-11 col-lg-11 form-control form-control-sm cap"
                    formControlName="memberIdTo"
                  />
                </div>
                <div class="col-md-6"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="givenName"> Förnamn </label>
              <input
                type="text"
                class="form-control form-control-sm cap"
                id="givenName"
                formControlName="givenName"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="familyName"> Efternamn </label>
              <input
                type="text"
                class="form-control form-control-sm cap"
                id="familyName"
                formControlName="familyName"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="homeZipCode"> Postnummer </label>
              <input
                type="text"
                class="form-control form-control-sm cap"
                id="homeZipCode"
                formControlName="homeZipCode"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="homeCity"> Postort </label>
              <input
                type="text"
                class="form-control form-control-sm cap"
                id="homeCity"
                formControlName="homeCity"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="homeCountry">Land</label>
              <select
                class="form-control form-control-sm"
                id="homeCountry"
                formControlName="homeCountry"
              >
                <option></option>
                <option *ngFor="let c of countries" [value]="c.name">
                  {{ c.name }}
                </option>
              </select>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title> System datum </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <!--div class="row">
            <div class="form-group col-md-3">
              <label for="membershipCreatedFrom"> Skapad </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipCreatedFrom"
              ></app-calendarnotrequired>
            </div>
            <div class="form-group col-md-3">
              <label for="membershipCreatedTo"> &nbsp; </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipCreatedTo"
              ></app-calendarnotrequired>
            </div>
            <div class="form-group col-md-3">
              <label for="membershipChangedFrom"> Ändrad </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipChangedFrom"
              ></app-calendarnotrequired>
            </div>
            <div class="form-group col-md-3">
              <label for="membershipChangedTo"> &nbsp; </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipChangedTo"
              ></app-calendarnotrequired>
            </div>
          </div-->

          <div class="d-flex d-justify-content-between gap-1 ms-2">
            <div class="form-group">
              <label for="membershipCreatedFrom"> Skapad </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipCreatedFrom"
              ></app-calendarnotrequired>
            </div>
            <div class="form-group">
              <label for="membershipCreatedTo"> &nbsp; </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipCreatedTo"
              ></app-calendarnotrequired>
            </div>
            <div class="form-group">
              <label for="membershipChangedFrom"> Ändrad </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipChangedFrom"
              ></app-calendarnotrequired>
            </div>
            <div class="form-group">
              <label for="membershipChangedTo"> &nbsp; </label>
              <app-calendarnotrequired
                [form]="memberform"
                formName="membershipChangedTo"
              ></app-calendarnotrequired>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title> Födelseår </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row">
  
            <div class="col-md-11">
             <table>
                <tr>
                  <td>
                    <p-listbox
                      [options]="years"
                      formControlName="selectedYears"
                      [multiple]="true"
                      [checkbox]="false"
                      [filter]="false"
                      optionLabel="year"
                      [listStyle]="{ 'max-height': '150px' }"
                      [style]="{ 'min-width': '110px', width: '110px' }"
                    >
                    </p-listbox>

                  


                   
                  </td>
                  <td style="width: 100px">
                    <div style="max-height: 200px; overflow-y: auto">
                      <div
                        *ngFor="let y of memberform.get('selectedYears').value"
                        style="margin-left: 40px"
                      >
                        {{ y.year }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      *ngIf="memberform.get('selectedYears').value?.length > 0"
                      class="col-md-1"
                    >
                      <button
                        class="btn-small btn-primary"
                        style="width: 15px; margin-left: 4px"
                        title="Rensa valda år"
                        (click)="clearSelectedYears()"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <br />
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title> Epost </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-6">
              Epost1:<br />
              <p-selectButton
                [options]="epost1"
                formControlName="email1Exists"
              ></p-selectButton>
            </div>
            <br />
            <div class="col-md-6">
              Epost2:<br />
              <p-selectButton
                [options]="epost2"
                formControlName="email2Exists"
              ></p-selectButton>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title> SOFT prenumeration </mat-panel-title>
            
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-6">
              <p-selectButton
                [options]="soft"
                formControlName="isSoftSubscriber"
              ></p-selectButton>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
      <div class="col-xs-12 col-md-6 col-xl-4">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title> Medlemskap </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div>
              Medlemskap i <br />
              <div class="d-flex justify-content-start align-items-center">
                <div>
              <p-selectButton
                [options]="someorall"
                formControlName="membershipSomeOrAll"
              ></p-selectButton>
                </div>
                <div class="ms-4">


 <button
                  *ngIf="memberform.get('membershipSomeOrAll').value"
                  class="btn-small btn-primary"
                  (click)="displayMembershipInstitutions = true"
                >
                  <i class="fa fa-plus"></i>
                </button>
                <button
                  *ngIf="memberform.get('membershipSomeOrAll').value"
                  class="btn-small btn-primary ms-1"
                  title="Rensa valda institutioner"
                  (click)="membershipselectedinstitutions = []"
                >
                  <i class="fa fa-trash"></i>
                </button>


                </div>
              </div>
            </div>
            <!--div class="col-md-2">
              <br />
              <div class="d-flex justify-content-between gap-1">
               
              </div>
            </div-->
            <div class="col-md-5">
              <table
                style="
                  border: 1px solid lightgrey;
                  border-radius: 3px;
                  width: 280px;
                "
              >
                <tr *ngFor="let x of membershipselectedinstitutions">
                  <td>{{ x.name }}</td>
                  <td align="right">
                    <i
                      class="fa fa-times"
                      (click)="removeMembershipSelectedInstitution(x.id)"
                      title="Ta bort vald institution"
                    ></i>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <br />
          <!--div class="row">
            <div class="col-md-12">
              Medlemskapet påbörjades mellan<br />
              <div class="row" style="margin-left: 1px">
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipStartedFrom"
                ></app-calendarnotrequired
                >&nbsp;
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipStartedTo"
                ></app-calendarnotrequired>
                <button
                  class="btn btn-primary"
                  (click)="
                    setDate('membershipStartedTo', 'membershipEndedFrom')
                  "
                  style="margin-left: 10px"
                >
                  Just nu
                </button>
              </div>
            </div>
          </div-->
          <div>Medlemskapet påbörjades mellan</div>
          <div class="d-flex justify-content-start">
            <div class="d-flex justify-content-between gap-1">
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipStartedFrom"
                ></app-calendarnotrequired>
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipStartedTo">
                </app-calendarnotrequired>
                <button
                  class="btn btn-primary"
                  (click)="
                    setDate('membershipStartedTo', 'membershipEndedFrom')
                  "
                  style="margin-left: 10px"
                >
                  Just nu
                </button>
                </div>
          </div>
          <br />
          <!--div class="row">
            <div class="col-md-12">
              Medlemskapet avslutades mellan<br />
              <div class="row" style="margin-left: 1px">
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipEndedFrom"
                ></app-calendarnotrequired>
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipEndedTo"
                ></app-calendarnotrequired>
              </div>
            </div>
          </div-->
           <div>Medlemskapet avslutades mellan</div>
          <div class="d-flex justify-content-start">
            <div class="d-flex justify-content-between gap-1">
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipEndedFrom"
                ></app-calendarnotrequired>
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="membershipEndedTo"
                ></app-calendarnotrequired>
                </div>
          </div>
          <hr />
          <div class="row">
            <div>
              Icke medlemskap i <br />
              <div class="d-flex justify-content-start align-items-center">
              <div>
                <p-selectButton
                [options]="someorall"
                formControlName="nomembershipSomeOrAll"
              ></p-selectButton>
              </div>
              <div class="ms-4">
              <button
                  *ngIf="memberform.get('nomembershipSomeOrAll').value"
                  class="btn-small btn-primary"
                  (click)="displayNoMembershipInstitutions = true"
                >
                  <i class="fa fa-plus"></i>
                </button>
                <button
                  *ngIf="memberform.get('nomembershipSomeOrAll').value"
                  class="btn-small btn-primary ms-1"
                  title="Rensa valda institutioner"
                  (click)="nomembershipselectedinstitutions = []"
                >
                  <i class="fa fa-trash"></i>
                </button>
                </div>
            </div>
            </div>
            <br />
            <div class="col-md-5">
              <table
                style="
                  border: 1px solid lightgrey;
                  border-radius: 3px;
                  width: 280px;
                "
              >
                <tr *ngFor="let x of nomembershipselectedinstitutions">
                  <td>{{ x.name }}</td>
                  <td align="right">
                    <i
                      class="fa fa-times"
                      (click)="removeNoMembershipSelectedInstitution(x.id)"
                      title="Ta bort vald institution"
                    ></i>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <br />
          <!--div class="row">
            <div class="col-md-12">
              Medlemskapet påbörjades mellan<br />
              <div class="row" style="margin-left: 1px">
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipStartedFrom"
                ></app-calendarnotrequired>
                &nbsp;
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipStartedTo"
                ></app-calendarnotrequired>
                <button
                  class="btn btn-primary"
                  (click)="
                    setDate('noMembershipStartedTo', 'noMembershipEndedFrom')
                  "
                  style="margin-left: 10px"
                >
                  Just nu
                </button>
              </div>
            </div>
          </div-->
          <div>Medlemskapet påbörjades mellan</div>
          <div class="d-flex justify-content-start">
            <div class="d-flex justify-content-between gap-1">
                  <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipStartedFrom"
                ></app-calendarnotrequired>
                
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipStartedTo"
                ></app-calendarnotrequired>
                <button
                  class="btn btn-primary"
                  (click)="
                    setDate('noMembershipStartedTo', 'noMembershipEndedFrom')">
                  Just nu
                </button>
            </div>
          </div>
          <br />

          <!--div class="row">
            <div class="col-md-12">
              Medlemskapet avslutades mellan<br />
              <div class="row" style="margin-left: 1px">
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipEndedFrom"
                ></app-calendarnotrequired>
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipEndedTo"
                ></app-calendarnotrequired>
              </div>
            </div>
          </div-->
           <div>Medlemskapet avslutades mellan</div>
          <div class="d-flex justify-content-start">
            <div class="d-flex justify-content-between gap-1">
               <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipEndedFrom"
                ></app-calendarnotrequired>
                <app-calendarnotrequired
                  [form]="memberform"
                  formName="noMembershipEndedTo"
                ></app-calendarnotrequired>
                </div>
          </div>
        </mat-expansion-panel>
      </div>
      <div class="col-xs-12 col-md-6 col-xl-4"></div>
    </div>
  </form>
</div>
  <!--div *ngIf="memberPhoto">
  <img [src]="'data:image/jpeg;base64,' + memberPhoto" />
</div-->

<div class="me-3 ms-3">
<div *ngIf="memberresult.length > 0" class="border mt-3 d-flex justify-content-between align-items-center">
  <div class="ms-4">
    <p-menubar [model]="items">
        
          <span
            *ngIf="selectedmembers.length > 0"
            class="text-info btn-link mr-3 cursor-pointer"
            title="Etikettformat A4 ark Avery 3475 eller Herma 4453"
            >Etikettinfo</span
          >
      </p-menubar>
  </div>
 
  <div class="me-4 d-flex justify-content-between gap-4 align-items-center">
    <div>Resultat: {{ memberresult?.length }}</div>
    <div>Välj alla:
            <mat-checkbox
              #checkAll
              (change)="checkuncheckAll(checkAll)"
            ></mat-checkbox></div>
 </div>

</div>


  <!--div *ngIf="memberresult.length > 0">
    <div class="resultdiv">
      <p-menubar [model]="items">
        <div class="d-flex justify-content-end mt-2 align-items-center">
          <div class="d-flex justify-content-between gap-4 flex-nowrap">
          <span
            *ngIf="selectedmembers.length > 0"
            class="text-info btn-link mr-3 cursor-pointer"
            title="Etikettformat A4 ark Avery 3475 eller Herma 4453"
            >Etikettinfo</span
          >
          <span>Resultat: {{ memberresult?.length }}</span>
          <span class="ml-4"
            >Välj alla:
            <mat-checkbox
              #checkAll
              (change)="checkuncheckAll(checkAll)"
            ></mat-checkbox>
          </span>
          </div>
        </div>
      </p-menubar>
    </div>
  </div-->  

      <table *ngIf="!showMailView && memberresult?.length > 0"
        matSort
        class="table table-bordered border"
        (matSortChange)="sortData($event)"
        matSortDisableClear="true"
      >
        <thead role="rowgroup">
          <tr>
            <th mat-sort-header="id">Id</th>
            <th mat-sort-header="givenName">Förnamn</th>
            <th mat-sort-header="familyName">Efternamn</th>
            <th mat-sort-header="homeCity">Ort</th>
            <th mat-sort-header="email">Epost</th>
            <th>Primärinstitution</th>
            <th mat-sort-header="institutionName">Institution</th>
            <th mat-sort-header="institutionVisitingCity">Besöksort</th>
            <th mat-sort-header="isSubscriber">SOFT</th>
            <th mat-sort-header="membershipStartDate">Startdatum</th>
            <th mat-sort-header="membershipEndDate">Slutdatum</th>
            <th>Välj</th>
          </tr>
        </thead>
        <tr *ngFor="let r of memberresult">
          <td style="text-align: right">
            <a [routerLink]="['/memberform/id/', r.id]">{{ r.id }}</a>
          </td>
          <td>{{ r.givenName }}</td>
          <td>{{ r.familyName }}</td>
          <td>{{ r.h_City }}</td>
          <td>{{ r.email1 }}</td>
          <td *ngIf="r.primaryInstitution2.id !== 99999">
            <a
              [routerLink]="['/institutions/id/', r.primaryInstitution2?.id]"
              title="Titta på institutionsdetaljer"
              >{{ r.primaryInstitution2.shortName }}
              {{ r.primaryInstitution2.name }}</a
            >
          </td>
          <td *ngIf="r.primaryInstitution2.id === 99999">
            {{ r.primaryInstitution2.shortName }}
            {{ r.primaryInstitution2.name }}
          </td>
          <td>
            <a
              [routerLink]="['/institutions/id/', r.institutionId]"
              title="Titta på institutionsdetaljer"
              >{{ r.institutionShortName }} {{ r.institutionName }}</a
            >
          </td>
          <td>{{ r.institutionVisitingCity }}</td>
          <td *ngIf="r.isSubscriber">
            <i class="fa fa-check" aria-hidden="true" style="color: green"></i>
          </td>
          <td *ngIf="!r.isSubscriber">
            <i class="fa fa-times" aria-hidden="true" style="color: red"></i>
          </td>
          <td>{{ r.membershipStartDate | date : "yyyy-MM-dd" }}</td>
          <td>{{ r.membershipEndDate | date : "yyyy-MM-dd" }}</td>
          <td>
            <div class="d-flex align-items-center gap-1">
              <mat-checkbox
                *ngIf="r.checkbox"
                #inputEl
                (change)="add(r, inputEl)"
                [checked]="r.checked"
              ></mat-checkbox
              ><i
                *ngIf="r.email1 && r.checkbox"
                class="fa fa-envelope-o"
                aria-hidden="true"
              ></i>
            </div>
          </td>
        </tr>
      </table>
      </div>
    <!--/div>
  </div>
</div-->
<!--div *ngIf="showLabelsAsHtml">
  <div class="row">
    <div *ngFor="let member of selectedmembers" class="col-xl-3">
      <div class="ml-2 mr-2 mb-4 p-1" style="border:1px solid lightgrey;">
        <div style="font-weight: bold;">{{member.givenName}} {{member.familyName}}</div>
        <div *ngIf="member.h_CareOf">{{member.h_CareOf}}</div>
        <div *ngIf="!member.h_CareOf">&nbsp;</div>
        <div>{{member.h_Street}}</div>
        <div>{{member.h_ZipCode}} {{member.h_City}}</div>
      </div>
    </div>
  </div>
</div-->
<div *ngIf="showMailView">
  <app-mail
    [memberlist]="selectedmembers"
    (closeEmail)="closeEmail($event)"
  ></app-mail>
  
</div>

<p-dialog
  header="Medlemskap i"
  [(visible)]="displayMembershipInstitutions"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10"
  [draggable]="true"
  [resizable]="true"
  [maximizable]="true"
  appendTo="body"
>
  <app-institution-chooser
    [selectedinstitutions]="membershipselectedinstitutions"
    [form]="memberform"
    (institutionSelected)="setSelectedInstitutions($event, 'membership')"
  ></app-institution-chooser>
</p-dialog>

<p-dialog
  header="Icke medlemskap i"
  [(visible)]="displayNoMembershipInstitutions"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10"
  [draggable]="true"
  [resizable]="true"
  [maximizable]="true"
  appendTo="body"
>
  <app-institution-chooser
    [selectedinstitutions]="nomembershipselectedinstitutions"
    [form]="memberform"
    (institutionSelected)="setSelectedNoInstitutions($event, 'nomembership')"
  ></app-institution-chooser>
</p-dialog>
